(() => {
  const storageKey = "build-a-box";

  const safeJsonParse = (value, fallback) => {
    try {
      const parsed = JSON.parse(value);
      return parsed || fallback;
    } catch (error) {
      return fallback;
    }
  };

  const normaliseFilterValue = (value) =>
    String(value || "")
      .toLowerCase()
      .trim()
      .replace(/&/g, "and")
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "");

  const escapeHTML = (value) =>
    String(value || "").replace(
      /[&<>"']/g,
      (character) =>
        ({
          "&": "&amp;",
          "<": "&lt;",
          ">": "&gt;",
          '"': "&quot;",
          "'": "&#39;",
        })[character],
    );

  const parseMoney = (value) => Number(String(value || "0").replace(/[^0-9.-]/g, "")) || 0;

  const applyDiscount = (value, discount) => {
    const parsedDiscount = Number(discount) || 0;
    if (parsedDiscount > 0 && parsedDiscount <= 1) return value * parsedDiscount;
    return value * (1 - parsedDiscount / 100);
  };

  const parsePassports = () => {
    const parsed = safeJsonParse(localStorage.getItem("passport"), []);
    return Array.isArray(parsed) ? parsed : [];
  };

  class BuildABoxIntro extends HTMLElement {
    connectedCallback() {
      if (this.initialised) return;
      this.initialised = true;
      this.config = this.querySelector("[data-bab-intro-config]");
      this.dogId = this.getCurrentDogId();
      this.showDoNotQualify =
        this.dataset.showDoNotQualify || this.config?.dataset.showDoNotQualify || "false";
      this.runQualifyingOfferState();
      this.showDoNotQualifyModal();
      this.initPassportCta();
    }

    getCurrentDogId() {
      const urlDogId = new URLSearchParams(window.location.search).get("dogId");
      return String(urlDogId || this.dataset.dogId || this.config?.dataset.dogId || "");
    }

    runQualifyingOfferState() {
      if (window.QF?.has_had_subscription !== false) return;
      if (localStorage.getItem("babQualifyOffer") !== "true") return;

      localStorage.setItem("babStage", "bab-recommendations");
      if (window.QF?.dogId) localStorage.setItem("babId", window.QF.dogId);

      document
        .querySelectorAll("[show-bab-offer]")
        .forEach((element) => element.classList.remove("hidden"));
      document
        .querySelectorAll("[no-show-bab-offer]")
        .forEach((element) => element.classList.add("hidden"));

      const firstBoxDiscount = Number(window.QF?.buildABox?.firstBoxDiscount || 0);
      document.querySelectorAll(".was-price").forEach((wasPriceElement, index) => {
        const nowPriceElement = document.querySelectorAll(".now-price")[index];
        const wasPrice = parseMoney(wasPriceElement.textContent);
        if (wasPrice && nowPriceElement && firstBoxDiscount) {
          nowPriceElement.textContent = `£${(wasPrice * firstBoxDiscount).toFixed(2)}`;
        }
      });
    }

    showDoNotQualifyModal() {
      if (this.showDoNotQualify !== "true") return;
      if (localStorage.getItem("babQualifyOffer") !== "true") return;

      const modalTrigger = this.querySelector('[data-modal-trigger="bab-do-not-qualify"]');
      if (modalTrigger) modalTrigger.click();
      localStorage.setItem("babQualifyOffer", "false");
    }

    initPassportCta() {
      const passportCta = this.querySelector("[data-bab-passport-cta]");
      if (!passportCta) return;

      const passportSelectWrapper = passportCta.querySelector(".passport-select");
      const passportSelect = passportSelectWrapper
        ? passportSelectWrapper.querySelector("select")
        : null;
      const passportSelectText = passportCta.querySelector(".passport-select-text");
      const passportText = passportCta.querySelector(".passport-text");
      const passportBtn = passportCta.querySelector(".passport-btn");
      const passportIcon = passportCta.querySelector(".passport-icon");
      const passports = parsePassports();

      const showCreatePassportCta = () => {
        if (passportIcon) passportIcon.classList.remove("hidden");
        if (passportText) passportText.classList.remove("hidden");
        if (passportBtn) passportBtn.classList.remove("hidden");
        if (passportSelectText) passportSelectText.classList.add("hidden");
        if (passportSelectWrapper) passportSelectWrapper.classList.add("hidden");
      };

      const showPassportSelect = () => {
        if (passportIcon) passportIcon.classList.remove("hidden");
        if (passportText) passportText.classList.add("hidden");
        if (passportBtn) passportBtn.classList.add("hidden");
        if (passportSelectText) passportSelectText.classList.remove("hidden");
        if (passportSelectWrapper) passportSelectWrapper.classList.remove("hidden");
      };

      if (!passports.length) {
        showCreatePassportCta();
        return;
      }

      showPassportSelect();

      const selectablePassports = passports.filter((passport) =>
        this.isPassportSelectable(passport),
      );
      if (passportSelect) {
        passportSelect.replaceChildren();
        selectablePassports.forEach((passport) => {
          this.addPassportOption(passportSelect, passport);
        });
      }

      const selectedPassport =
        selectablePassports.find((passport) => String(passport.id) === this.dogId) ||
        selectablePassports[0];

      if (passportSelect && selectedPassport) {
        passportSelect.value = String(selectedPassport.id);
      }

      if (selectedPassport) this.applyPassport(selectedPassport);

      if (passportSelect) {
        passportSelect.addEventListener("change", () => {
          if (!passportSelect.value || passportSelect.value === this.dogId) return;
          const selectedPassportData = selectablePassports.find(
            (passport) => String(passport.id) === passportSelect.value,
          );
          if (selectedPassportData) this.applyPassport(selectedPassportData);

          const url = new URL(window.location.href);
          url.searchParams.set("dogId", passportSelect.value);
          localStorage.setItem("babId", passportSelect.value);
          window.location.assign(url.toString());
        });
      }
    }

    isPassportSelectable(passport) {
      if (passport.dog_dob) {
        const ageInMilliseconds = new Date() - new Date(passport.dog_dob);
        const ageInWeeks = ageInMilliseconds / (1000 * 60 * 60 * 24 * 7);
        return ageInWeeks >= 8;
      }

      return true;
    }

    addPassportOption(passportSelect, passport) {
      if (!passportSelect) return;
      const option = document.createElement("option");
      option.value = String(passport.id);
      option.text = passport.dog_name;
      option.selected = String(passport.id) === this.dogId;
      passportSelect.add(option);
    }

    applyPassport(passport) {
      this.dogId = String(passport.id || this.dogId || "");
      localStorage.setItem("babId", this.dogId);
      if (window.QF?.updateRecommendationContextFromDogData) {
        window.QF.updateRecommendationContextFromDogData(passport);
      }

      this.renderDogInfo(passport);
      this.applyAgeFilters(passport);
      this.applyFavouriteFilters(passport);
      this.applyPreferenceTabs(passport);
      this.updateWillLast(passport);

      if (window.QF?.renderProductCardFeedingAmounts) {
        window.QF.renderProductCardFeedingAmounts(document);
      }
    }

    renderDogInfo(passport) {
      const dogInfo = this.querySelector("[data-bab-dog-info]");
      if (!dogInfo) return;

      let dogAgeValue = "";
      if (passport.dog_age === "1-7 years adult") dogAgeValue = "an adult dog";
      if (passport.dog_age === "7+ senior") dogAgeValue = "a senior dog";
      if (passport.dog_age === "8 - 52 weeks puppy") {
        const week = 7 * 24 * 60 * 60 * 1000;
        dogAgeValue = `a ${Math.floor(Math.abs(new Date() - new Date(passport.dog_dob)) / week)} week old puppy`;
      }

      const favourites = this.formatFavourites(passport.dog_favourites);
      const activity = String(passport.dog_activity || "").replaceAll("_", " ");
      const wrapper = document.createElement("div");
      wrapper.classList.add("fmf-summary");
      wrapper.innerHTML = `
        <div class="summary-title">
          <span class="italic">${escapeHTML(passport.dog_name)}</span>
          <strong>is</strong>
          <span>${escapeHTML(dogAgeValue)}</span>
          <strong>and</strong> likes <span>${escapeHTML(favourites)}</span>.
          <strong><span class="italic">${escapeHTML(passport.dog_name)}</span> weighs</strong>
          <span>${escapeHTML(passport.dog_weight_current)}</span>kg <strong>and is</strong>
          <span>${escapeHTML(activity)}</span>.
        </div>`;
      dogInfo.replaceChildren(wrapper);
    }

    formatFavourites(value) {
      let favourites = [];
      if (Array.isArray(value)) favourites = value;
      if (typeof value === "string") {
        const fishTypes = ["herring", "ocean fish", "salmon", "sardines", "white fish"];
        favourites = value.split("|").filter((favourite) => !fishTypes.includes(favourite));
      }

      if (!favourites.length) return "Everything";
      if (favourites.length === 1) return favourites[0];
      return `${favourites.slice(0, -1).join(", ")} and ${favourites[favourites.length - 1]}`;
    }

    checkMatchingInputs(selector) {
      document.querySelectorAll(selector).forEach((checkbox) => {
        checkbox.checked = true;
        checkbox.dispatchEvent(new Event("change", { bubbles: true }));
      });
    }

    applyAgeFilters(passport) {
      const age = String(passport.dog_age || "").toLowerCase();
      if (age === "8 - 52 weeks puppy")
        this.checkMatchingInputs('[data-stages] input[value="puppy"]');
      if (age === "1-7 years adult") this.checkMatchingInputs('[data-stages] input[value="adult"]');
      if (age === "7+ senior") this.checkMatchingInputs('[data-stages] input[value="senior"]');
    }

    applyFavouriteFilters(passport) {
      if (!passport.dog_favourites) return;

      if (
        typeof passport.dog_favourites === "string" &&
        passport.dog_favourites.toLowerCase() === "all recipes"
      ) {
        this.checkMatchingInputs('[data-flavours] input[type="checkbox"]');
        return;
      }

      const favourites = Array.isArray(passport.dog_favourites)
        ? passport.dog_favourites
        : String(passport.dog_favourites).split("|");

      favourites.forEach((favourite) => {
        this.checkMatchingInputs(
          `[data-flavours] input[value="${normaliseFilterValue(favourite)}"]`,
        );
      });
    }

    applyPreferenceTabs(passport) {
      const tabMap = {
        "dog-feeding-wet-only": '[data-bab-tab="dry-dog-food"]',
        "dog-feeding-dry-only": '[data-bab-tab="wet-dog-food"]',
      };
      const tab = document.querySelector(tabMap[passport.dog_preferences]);
      if (!tab) return;

      const heading = tab.querySelector(".heading-h3");
      const button = tab.querySelector(".bab-products-button");
      const filters = tab.querySelector(".bab-products-filters");
      const slider = tab.querySelector(".bab-products-slider");
      const productMatchIcons = tab.querySelectorAll(".product-match");

      if (heading && !heading.querySelector("[data-bab-hidden-label]")) {
        heading.insertAdjacentHTML(
          "beforeend",
          "<span data-bab-hidden-label>(Hidden based on preferences)</span>",
        );
      }
      if (filters) filters.classList.add("hidden");
      if (slider) slider.classList.add("hidden");
      if (button) button.style.display = "block";
      productMatchIcons.forEach((icon) => icon.classList.add("hidden"));

      button?.addEventListener(
        "click",
        () => {
          button.style.display = "none";
          filters?.classList.remove("hidden");
          slider?.classList.remove("hidden");
          heading?.querySelector("[data-bab-hidden-label]")?.remove();
        },
        { once: true },
      );
    }

    updateWillLast(passport) {
      document.querySelectorAll(".will-last").forEach((element) => {
        const productSize = Number(element.getAttribute("data-size"));
        if (!productSize) return;

        let days = 0;
        if (element.getAttribute("data-type") === "tray") {
          const traySize = Number(element.getAttribute("data-tray-size"));
          if (Number(passport.dog_wet_grams) && traySize) {
            days = Math.round(productSize / (Number(passport.dog_wet_grams) / traySize));
          }
        } else if (Number(passport.dog_dry_grams)) {
          days = Math.round((productSize * 1000) / Number(passport.dog_dry_grams));
        }

        if (!days) return;
        element.textContent = `Last up to ${days} days`;
        if (!Number.isFinite(days)) element.classList.add("hidden");
      });
    }
  }

  class BuildABoxCart extends HTMLElement {
    connectedCallback() {
      if (this.initialised) return;
      this.initialised = true;
      this.productCache = new Map();
      this.frequencySelect = this.querySelector("[data-bab-frequency]");
      this.addButton = this.querySelector("[data-add-bab-to-cart]");
      this.feedback = this.querySelector("[data-bab-cart-feedback]");
      this.itemsContainer = this.querySelector("[data-bab-items]");
      this.mobileToggle = this.querySelector("[data-bab-mobile-cart-toggle]");
      this.discountSettings = {
        first: Number(
          window.QF?.buildABox?.firstBoxDiscount || this.dataset.firstBoxDiscount || 10,
        ),
        second: Number(
          window.QF?.buildABox?.secondBoxDiscount || this.dataset.secondBoxDiscount || 10,
        ),
        third: Number(
          window.QF?.buildABox?.thirdBoxDiscount || this.dataset.thirdBoxDiscount || 10,
        ),
      };
      this.money = new Intl.NumberFormat("en-GB", {
        style: "currency",
        currency: this.dataset.currency || "GBP",
      });
      this.removeIcon = this.querySelector("[data-bab-remove-icon]")?.innerHTML?.trim() || "×";
      this.placeholderImage =
        this.querySelector("[data-bab-placeholder-image]")?.innerHTML?.trim() || "";
      this.boundRenderItems = this.renderItems.bind(this);
      this.boundStorage = (event) => {
        if (event.key === storageKey) this.renderItems();
      };

      this.addEventListener("click", this.handleClick.bind(this));
      this.frequencySelect?.addEventListener("change", this.boundRenderItems);
      window.addEventListener("bab_updated", this.boundRenderItems);
      window.addEventListener("storage", this.boundStorage);
      this.renderItems();
    }

    disconnectedCallback() {
      window.removeEventListener("bab_updated", this.boundRenderItems);
      window.removeEventListener("storage", this.boundStorage);
    }

    getBox() {
      const parsed = safeJsonParse(localStorage.getItem(storageKey), []);
      return Array.isArray(parsed) ? parsed : [];
    }

    setBox(items) {
      localStorage.setItem(storageKey, JSON.stringify(items));
      window.dispatchEvent(new CustomEvent("bab_updated"));
    }

    formatMoney(value) {
      return this.money.format(Math.max(value, 0));
    }

    lineKey(item) {
      return `${item.handle}:${item.variant}`;
    }

    planIndex() {
      return Math.max(this.frequencySelect?.selectedIndex ?? 0, 0);
    }

    selectedSellingPlan(item) {
      if (!Array.isArray(item.selling_plan) || !item.selling_plan.length) return null;
      return item.selling_plan[this.planIndex()] || item.selling_plan[0];
    }

    parsePassportCollection(value) {
      if (Array.isArray(value)) return value;
      if (!value) return [];

      const parsedValue = typeof value === "string" ? safeJsonParse(value, null) : value;
      if (Array.isArray(parsedValue)) return parsedValue;
      if (Array.isArray(parsedValue?.passports)) return parsedValue.passports;
      if (parsedValue?.dog_name) return [parsedValue];
      return [];
    }

    getSelectedDogName() {
      const urlDogId = new URLSearchParams(window.location.search).get("dogId");
      const selectedDogId = String(
        urlDogId || localStorage.getItem("babId") || window.QF?.dogId || "",
      );
      const passports = [
        ...parsePassports(),
        ...this.parsePassportCollection(window.QF?.customer?.passports),
      ];

      const selectedPassport = selectedDogId
        ? passports.find((passport) => String(passport?.id || "") === selectedDogId)
        : null;
      const fallbackPassport = passports.length === 1 ? passports[0] : null;
      return String((selectedPassport || fallbackPassport)?.dog_name || "").trim();
    }

    productUrl(handle) {
      const root = window.Shopify?.routes?.root || "/";
      return `${root}products/${handle}.js`;
    }

    async fetchProduct(handle) {
      if (!handle) return null;
      if (this.productCache.has(handle)) return this.productCache.get(handle);
      const promise = fetch(this.productUrl(handle))
        .then((response) => (response.ok ? response.json() : null))
        .catch(() => null);
      this.productCache.set(handle, promise);
      return promise;
    }

    async getProductMeta(item) {
      const product = await this.fetchProduct(item.handle);
      const variant = product?.variants?.find(
        (candidate) => Number(candidate.id) === Number(item.variant),
      );
      const image =
        variant?.featured_image?.src || product?.featured_image || product?.images?.[0] || "";
      return {
        title: product?.title || item.title || item.handle?.replace(/-/g, " ") || "Product",
        url: product?.url
          ? `${product.url}?variant=${item.variant}`
          : `/products/${item.handle}?variant=${item.variant}`,
        image,
        variantTitle: variant?.title && variant.title !== "Default Title" ? variant.title : "",
        price: parseMoney(item.price),
        compareAtPrice: parseMoney(item.compare_at_price || item.price),
      };
    }

    setText(selector, value) {
      this.querySelectorAll(selector).forEach((element) => {
        element.textContent = value;
      });
    }

    setMobileCartOpen(isOpen) {
      this.classList.toggle("is-mobile-cart-open", isOpen);
      this.mobileToggle?.setAttribute("aria-expanded", String(isOpen));
    }

    calculateTotals(items) {
      const subtotal = items.reduce((sum, item) => {
        const compareAt = parseMoney(item.compare_at_price || item.price);
        return sum + compareAt * (Number(item.quantity) || 0);
      }, 0);
      const firstTotal = applyDiscount(subtotal, this.discountSettings.first);
      const secondTotal = applyDiscount(subtotal, this.discountSettings.second);
      const thirdTotal = applyDiscount(subtotal, this.discountSettings.third);
      return {
        count: items.reduce((sum, item) => sum + (Number(item.quantity) || 0), 0),
        firstTotal,
        secondTotal,
        thirdTotal,
        firstSaving: subtotal - firstTotal,
        secondSaving: subtotal - secondTotal,
        thirdSaving: subtotal - thirdTotal,
      };
    }

    renderTotals(items) {
      const totals = this.calculateTotals(items);
      this.setText("[data-bab-count]", String(totals.count));
      this.setText("[data-bab-total]", this.formatMoney(totals.firstTotal));
      this.setText("[data-bab-saving]", this.formatMoney(totals.firstSaving));
      this.setText("[data-bab-second-total]", this.formatMoney(totals.secondTotal));
      this.setText("[data-bab-second-saving]", this.formatMoney(totals.secondSaving));
      this.setText("[data-bab-third-total]", this.formatMoney(totals.thirdTotal));
      this.setText("[data-bab-third-saving]", this.formatMoney(totals.thirdSaving));
      if (this.addButton) this.addButton.disabled = totals.count === 0;
    }

    async renderItems() {
      const items = this.getBox();
      this.renderTotals(items);

      const hasOffer =
        window.QF?.has_had_subscription === false &&
        localStorage.getItem("babQualifyOffer") === "true";
      this.querySelectorAll(".show-bab-offer-first, .show-bab-offer-pricing").forEach((element) =>
        element.classList.toggle("hidden", !hasOffer),
      );
      this.querySelectorAll(".no-show-bab-offer-pricing").forEach((element) =>
        element.classList.toggle("hidden", hasOffer),
      );
      this.querySelectorAll(".bab-offer-full-pricing").forEach((element) =>
        element.classList.toggle("hidden", !hasOffer),
      );

      if (!this.itemsContainer) return;
      if (!items.length) {
        this.itemsContainer.innerHTML = '<p class="message">Your box is empty</p>';
        return;
      }

      const metaItems = await Promise.all(
        items.map(async (item) => ({ item, meta: await this.getProductMeta(item) })),
      );
      this.itemsContainer.innerHTML = metaItems
        .map(({ item, meta }) => this.renderLineItem(item, meta))
        .join("");
    }

    renderLineItem(item, meta) {
      const quantity = Number(item.quantity) || 1;
      const compareAt = meta.compareAtPrice || meta.price;
      const price = meta.price || compareAt;
      const lineTotal = applyDiscount(compareAt * quantity, this.discountSettings.first);
      const escapedTitle = escapeHTML(meta.title);
      const escapedVariantTitle = escapeHTML(meta.variantTitle);
      const imageHtml = meta.image
        ? `<img src="${meta.image}" alt="${escapedTitle}" loading="lazy">`
        : this.placeholderImage;
      const key = this.lineKey(item);

      return `
        <div class="item bab-cart-item" data-bab-line="${key}">
          <a class="img-wrapper" href="${meta.url}" aria-label="View ${escapedTitle}">${imageHtml}</a>
          <div class="info-wrapper">
            <div class="top">
              <div>
                <a href="${meta.url}">${escapedTitle}</a>
                <button class="remove-item" type="button" data-bab-remove="${key}" aria-label="Remove ${escapedTitle}">${this.removeIcon}</button>
              </div>
              ${meta.variantTitle ? `<span>${escapedVariantTitle}</span>` : ""}
            </div>
            <div class="mid selling-plan" style="display: none;"><strong>Subscribe:</strong> ${escapeHTML(this.frequencySelect?.value || "Every 4 weeks")}</div>
            <div class="bottom">
              <div class="quantity-wrapper flex">
                <button class="minus" type="button" data-bab-quantity="decrease" data-bab-key="${key}" aria-label="Decrease quantity">-</button>
                <span class="quantity">${quantity}</span>
                <button class="plus" type="button" data-bab-quantity="increase" data-bab-key="${key}" aria-label="Increase quantity">+</button>
              </div>
              <div class="sub-prices">
                ${compareAt > price ? `<span class="was-price">${this.formatMoney(compareAt * quantity)}</span>` : ""}
                <span class="now-price">${this.formatMoney(lineTotal)}</span>
              </div>
            </div>
          </div>
        </div>`;
    }

    updateQuantity(key, direction) {
      const nextItems = this.getBox().reduce((items, item) => {
        if (this.lineKey(item) !== key) {
          items.push(item);
          return items;
        }
        const nextQuantity = (Number(item.quantity) || 1) + (direction === "increase" ? 1 : -1);
        if (nextQuantity > 0) items.push({ ...item, quantity: nextQuantity });
        return items;
      }, []);
      this.setBox(nextItems);
    }

    removeItem(key) {
      this.setBox(this.getBox().filter((item) => this.lineKey(item) !== key));
    }

    async addBoxToCart() {
      const items = this.getBox();
      if (!items.length || !this.addButton) return;

      const dogName = this.getSelectedDogName();
      const cartItems = items.map((item) => {
        const line = { id: Number(item.variant), quantity: Number(item.quantity) || 1 };
        const sellingPlan = this.selectedSellingPlan(item);
        if (sellingPlan) line.selling_plan = Number(sellingPlan);
        if (dogName) line.properties = { "Build A Box": dogName };
        return line;
      });

      this.addButton.disabled = true;
      this.addButton.classList.add("loading");
      if (this.feedback) this.feedback.textContent = "Adding your box to basket...";

      try {
        if (window.cart && typeof window.cart.add === "function") {
          await window.cart.add(
            { items: cartItems },
            {
              requestName: "build-a-box",
              target: this.addButton,
            },
          );
        } else {
          const endpoint =
            window.Theme?.routes?.cart_add_url || this.dataset.cartAddUrl || "/cart/add.js";
          const response = await fetch(endpoint, {
            method: "POST",
            headers: { "Content-Type": "application/json", Accept: "application/json" },
            body: JSON.stringify({ items: cartItems }),
          });
          if (!response.ok) throw await response.json();
        }

        localStorage.removeItem(storageKey);
        window.dispatchEvent(new CustomEvent("bab_updated"));
        if (this.feedback) this.feedback.textContent = "Your box has been added to basket.";
      } catch (error) {
        console.error("Build a box add failed", error);
        if (this.feedback)
          this.feedback.textContent =
            error?.description || "Sorry, there was a problem adding your box. Please try again.";
      } finally {
        this.addButton.classList.remove("loading");
        this.renderItems();
      }
    }

    handleClick(event) {
      const infoToggle = event.target.closest("[toggle-bab-info]");
      if (infoToggle) {
        event.preventDefault();
        infoToggle.closest("[data-bab-breakdown-info]")?.classList.toggle("open");
        return;
      }

      if (event.target.closest("[data-bab-mobile-cart-toggle]")) {
        event.preventDefault();
        this.setMobileCartOpen(!this.classList.contains("is-mobile-cart-open"));
        return;
      }

      if (event.target.closest("[data-bab-mobile-cart-close]")) {
        event.preventDefault();
        this.setMobileCartOpen(false);
        return;
      }

      const quantityButton = event.target.closest("[data-bab-quantity]");
      if (quantityButton) {
        event.preventDefault();
        this.updateQuantity(quantityButton.dataset.babKey, quantityButton.dataset.babQuantity);
        return;
      }

      const removeButton = event.target.closest("[data-bab-remove]");
      if (removeButton) {
        event.preventDefault();
        this.removeItem(removeButton.dataset.babRemove);
        return;
      }

      if (event.target.closest("[data-add-bab-to-cart]")) {
        event.preventDefault();
        this.addBoxToCart();
      }
    }
  }

  class BuildABoxProducts extends HTMLElement {
    connectedCallback() {
      if (this.initialised) return;
      this.initialised = true;
      this.sliderElement = this.querySelector(".bab-products-slider");
      this.sliderRoot = this.sliderElement?.querySelector(".blaze-slider");
      this.trackElement = this.sliderRoot?.querySelector(".blaze-track");
      this.allCheckbox = this.querySelector(".filter-all-checkbox");
      this.checkboxes = Array.from(
        this.querySelectorAll('.bab-products-filters input[type="checkbox"]'),
      );
      // Blaze track children are plain elements, so every child is a slide.
      this.slides = this.trackElement ? Array.from(this.trackElement.children) : [];

      this.checkboxes.forEach((checkbox) => {
        checkbox.addEventListener("change", (event) => this.applyFilters(event.currentTarget));
      });

      if (this.allCheckbox && this.getSelectedFilters().length === 0)
        this.allCheckbox.checked = true;
      this.applyFilters(this.allCheckbox && this.allCheckbox.checked ? this.allCheckbox : null);
    }

    async getSliderController() {
      if (window.themeBlazeSliderController) return window.themeBlazeSliderController;
      try {
        const module = await import("@theme/blaze-slider-controller");
        return module?.blazeSliderController || null;
      } catch (error) {
        console.warn("Build a box: failed to load the slider controller", error);
        return null;
      }
    }

    async refreshSlider() {
      if (!this.sliderRoot) return;

      const controller = await this.getSliderController();
      if (!controller) return;

      // The track children changed, so Blaze has to re-measure before we page back to the start.
      controller.refresh(this.sliderRoot);
      controller.syncToSlideIndex(this.sliderRoot, 0);
    }

    getCardFilters(card) {
      const values = [card.dataset.diet, card.dataset.flavour, card.dataset.stage]
        .filter(Boolean)
        .flatMap((value) => value.split(","))
        .map((value) => value.trim())
        .filter(Boolean);
      return new Set(values);
    }

    getSelectedFilters() {
      return this.checkboxes
        .filter(
          (checkbox) => checkbox.checked && !checkbox.classList.contains("filter-all-checkbox"),
        )
        .map((checkbox) => checkbox.value);
    }

    renderSlides(selectedFilters) {
      if (!this.trackElement) return;
      const showAll = selectedFilters.length === 0 || selectedFilters.includes("all");
      const visibleSlides = this.slides.filter((slide) => {
        const card = slide.querySelector(".product-card");
        if (!card) return false;
        if (showAll) return true;
        const cardFilters = this.getCardFilters(card);
        return selectedFilters.some((filter) => cardFilters.has(filter));
      });

      visibleSlides.sort((firstSlide, secondSlide) => {
        const firstMatched = firstSlide.querySelector(".product-card.product-matched") ? 0 : 1;
        const secondMatched = secondSlide.querySelector(".product-card.product-matched") ? 0 : 1;
        return firstMatched - secondMatched;
      });

      this.trackElement.replaceChildren(...visibleSlides);
      this.refreshSlider();
    }

    applyFilters(changedCheckbox) {
      let selectedFilters = this.getSelectedFilters();

      if (changedCheckbox?.classList.contains("filter-all-checkbox") && changedCheckbox.checked) {
        this.checkboxes.forEach((checkbox) => {
          if (!checkbox.classList.contains("filter-all-checkbox")) checkbox.checked = false;
        });
        selectedFilters = ["all"];
      }

      if (selectedFilters.length === 0) {
        if (this.allCheckbox) this.allCheckbox.checked = true;
        selectedFilters = ["all"];
      } else if (this.allCheckbox && !selectedFilters.includes("all")) {
        this.allCheckbox.checked = false;
      }

      this.renderSlides(selectedFilters);
    }
  }

  class BuildABoxLandingHeader extends HTMLElement {
    connectedCallback() {
      localStorage.setItem("babQualifyOffer", "true");
      localStorage.setItem("babStage", "bab-landing");
      if (this.dataset.redirect === "true" && this.dataset.redirectUrl) {
        window.location.href = this.dataset.redirectUrl;
      }
    }
  }

  if (!customElements.get("build-a-box-intro"))
    customElements.define("build-a-box-intro", BuildABoxIntro);
  if (!customElements.get("build-a-box-cart"))
    customElements.define("build-a-box-cart", BuildABoxCart);
  if (!customElements.get("build-a-box-products"))
    customElements.define("build-a-box-products", BuildABoxProducts);
  if (!customElements.get("build-a-box-landing-header"))
    customElements.define("build-a-box-landing-header", BuildABoxLandingHeader);
})();
